var map = {
	"./TechBullion.png": 2306,
	"./about/back.svg": 8794,
	"./about/close.svg": 5094,
	"./about/date.svg": 9260,
	"./about/mission-m.png": 1865,
	"./about/mission.png": 2074,
	"./about/popup-shap.svg": 4334,
	"./about/shap.png": 6935,
	"./about/slide.png": 1994,
	"./about/team/LFG.jpg": 8008,
	"./about/team/brian.jpg": 5228,
	"./about/team/brian.png": 8095,
	"./about/team/cp.jpg": 9321,
	"./about/team/cp.png": 7345,
	"./about/team/crypdoebags.jpg": 580,
	"./about/team/danny.jpg": 2179,
	"./about/team/danny.png": 9084,
	"./about/team/phil.jpg": 7037,
	"./about/team/prash.jpg": 2294,
	"./about/vision-m.png": 6311,
	"./about/vision.png": 5281,
	"./benzinga.png": 5689,
	"./btn-arrow-blue.svg": 8099,
	"./btn-arrow-dark.svg": 36,
	"./btn-arrow.svg": 3525,
	"./copy.svg": 4924,
	"./digital.png": 918,
	"./dog-icon.png": 6925,
	"./eth-icon.png": 9380,
	"./g-d-bg.png": 610,
	"./home/Binance.svg": 4699,
	"./home/Coinbase.svg": 8286,
	"./home/LooksRare.png": 3717,
	"./home/Metamask.svg": 502,
	"./home/OpenSea.svg": 3039,
	"./home/arrow-blue.svg": 3632,
	"./home/banner.png": 9002,
	"./home/community-bg.png": 2454,
	"./home/copy.svg": 1357,
	"./home/dogcard.png": 3502,
	"./home/down.svg": 2759,
	"./home/earn.png": 3546,
	"./home/king.png": 254,
	"./home/kudoetokenomics.png": 186,
	"./home/news/1.webp": 6522,
	"./home/news/2.png": 7900,
	"./home/news/2.webp": 7567,
	"./home/news/3.webp": 6407,
	"./home/news/news3details/1.webp": 6981,
	"./home/news/news3details/2.png": 865,
	"./home/nft.png": 4723,
	"./home/partners/Bitmart.svg": 4974,
	"./home/partners/Bitrue.svg": 7482,
	"./home/partners/CMC.svg": 7268,
	"./home/partners/ChangeNOW.svg": 9587,
	"./home/partners/CoinGeko.svg": 9574,
	"./home/partners/Guardarian.svg": 8408,
	"./home/partners/Hotbit.svg": 9268,
	"./home/partners/LBANK.svg": 2642,
	"./home/partners/MEXC.svg": 9476,
	"./home/partners/Sandbox.svg": 8686,
	"./home/partners/Unicrypt.png": 5153,
	"./home/partners/Uniswap.svg": 2831,
	"./home/partners/ZT.svg": 1908,
	"./home/partners/gate.svg": 2121,
	"./home/partners/opensea.svg": 8835,
	"./home/partners/poloniex.svg": 1979,
	"./home/partners/unknown.svg": 4743,
	"./home/partners/web3.svg": 4534,
	"./home/play-btn.svg": 4837,
	"./home/product/1.png": 8734,
	"./home/product/2.png": 3972,
	"./home/product/3.png": 7265,
	"./home/product/4.png": 1557,
	"./home/product/5.png": 472,
	"./home/product/6.png": 9151,
	"./home/ranger.png": 2052,
	"./home/shap-bg.png": 5447,
	"./home/social-1.svg": 7566,
	"./home/social-2.svg": 2402,
	"./home/social-3.svg": 9101,
	"./home/social-4.svg": 5908,
	"./home/social-5.svg": 7553,
	"./home/social-6.svg": 7300,
	"./home/squar.png": 2012,
	"./home/tokenomic.png": 6058,
	"./home/union.svg": 7292,
	"./home/video.png": 2093,
	"./logo.jpeg": 2498,
	"./logo.svg": 2835,
	"./logo/logo.png": 7445,
	"./logo/logo.svg": 2470,
	"./logo/logo2.svg": 6880,
	"./logo2.jpeg": 1430,
	"./logo2.svg": 5743,
	"./market.png": 8495,
	"./select_arrow.svg": 993,
	"./staking/KDOE.webp": 7272,
	"./staking/info-icon.svg": 9572,
	"./staking/pool-bg.svg": 9814,
	"./staking/popup-bg.png": 2897,
	"./staking/staking.png": 649,
	"./staking/total-bg1.png": 7676,
	"./staking/total-bg2.png": 650,
	"./yahoo.png": 6958
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 990;